/**
 * LooksLab — Discount Codes
 *
 * The source of truth is now the D1 database (managed via the admin panel or seed.sql).
 * This file is kept for:
 *   1. The default codes used by worker/seed.sql
 *   2. calcDiscount() — still used client-side to compute the cart discount amount
 *      after the API has validated and returned the code object.
 *
 * To add/edit codes: use the Admin Panel (/admin → Discount Codes tab),
 * or edit worker/seed.sql and re-run `npm run db:seed` in the worker directory.
 */

export const discountCodes = [
  {
    code: 'WELCOME10',
    type: 'percent',
    value: 10,
    description: '10% off your first order',
    active: true,
    expiresAt: null,
    maxUses: null,
    minOrderTotal: 0,
  },
  {
    code: 'RESEARCH20',
    type: 'percent',
    value: 20,
    description: '20% off — research community',
    active: true,
    expiresAt: null,
    maxUses: null,
    minOrderTotal: 50,
  },
  {
    code: 'SAVE15',
    type: 'flat',
    value: 15,
    description: '$15 off orders over $100',
    active: true,
    expiresAt: null,
    maxUses: null,
    minOrderTotal: 100,
  },
  {
    code: 'ASCEND',
    type: 'percent',
    value: 15,
    description: '15% off — ascend protocol',
    active: false,
    expiresAt: null,
    maxUses: 50,
    minOrderTotal: 0,
  },
]

/**
 * Calculate the discount dollar amount for a validated code + subtotal.
 * Called client-side after the API has already validated the code.
 */
export function calcDiscount(code, subtotal) {
  if (!code) return 0
  if (code.type === 'percent') return Math.round(subtotal * (code.value / 100) * 100) / 100
  if (code.type === 'flat') return Math.min(code.value, subtotal)
  return 0
}
